export default __webpack_public_path__ + "static/media/dec2023-4.e73d98ae.jpg";